// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars!.palette.grey[600]
        },
        outlined: {
          lineHeight: '1rem',
          top: -4,
          '&.MuiInputLabel-sizeSmall': {
            lineHeight: '1em',
            top: 0
          },
          // Label flutuante usa o "notch" nativo do outline (legend) para cortar a borda —
          // nada de fundo sólido, que virava uma caixa escura no dark mode sobre superfícies
          // de tom diferente do background.paper.
          '&.MuiInputLabel-shrink': {
            background: 'transparent',
            top: 2,
            lineHeight: '1rem'
          }
        }
      }
    }
  };
}
